import {
  Component,
  OnInit,
  Inject
}
  from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA
}
  from '@angular/material/dialog';
import {
  FormGroup,
  Validators,
  FormBuilder
}
  from '@angular/forms';
import { BloqueFijasService } from 'src/app/servicios/bloque-fijas.service';

export interface DialogData {
  name: string;
  titulo: string;
  subTitulo: string;
  codigo: string;
  bloqueDestino: string;
  descripcionBloque: string;
}


@Component({
  selector: 'app-dialog-alert-text',
  templateUrl: './dialog-alert-text.component.html',
  styleUrls: ['./dialog-alert-text.component.css']
}) export class DialogAlertTextComponent implements OnInit {
  listaBloques = [];
  dialogoGroup: FormGroup;
  estadoGuardo: false;
  optionBloqueText: string;
  optionBloqueValue: string;
  constructor(private formBuilder : FormBuilder,
    public dialogRef: MatDialogRef<DialogAlertTextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private bloqueFijasService: BloqueFijasService) {


    this.dialogoGroup = this.formBuilder.group({
      txtTitulo: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      txtSubTitulo: ['', [Validators.required, Validators.maxLength(100)]],
      txtCodigo: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      cbxBloques: ['', Validators.required],
      txtDescripcionBloque: [''],
    });
  }

  ngOnInit() {
    this.cargarComboxOpciones();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeCbxBloques(event) {
    if (event.isUserInput) {
      this.optionBloqueText = event.source.viewValue;
      this.optionBloqueValue = event.source.value;

      this.data.bloqueDestino = event.source.value;
      this.data.descripcionBloque = event.source.viewValue;
    }
  }

  cargarComboxOpciones(){
    this.bloqueFijasService.getBloquesCombox().subscribe(result => {
      this.listaBloques = result;

    });
    this.dialogoGroup.controls['cbxBloques'].setValue(this.data.bloqueDestino);
  }

}
